"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.baseThemeConf = void 0;

var _polished = require("polished");

var _ = require("..");

var _utils = require("./utils");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var globalLight = {
  primaryColor: _.color.white,
  secondaryColor: _.color.darkBlue,
  primaryAccentColor: _.color.azure,
  secondaryAccentColor: _.color.orange
};

var light = _objectSpread(_objectSpread({}, globalLight), {}, {
  color: globalLight.primaryColor,
  borderColor: globalLight.primaryColor,
  backgroundColor: 'transparent',
  header: {
    top: {
      color: globalLight.primaryColor,
      backgroundColor: 'transparent',
      borderColor: globalLight.primaryColor,
      borderWidth: 0
    },
    scroll: {
      color: globalLight.primaryColor,
      backgroundColor: globalLight.secondaryColor,
      borderColor: globalLight.primaryColor,
      borderWidth: 0
    }
  },
  sidebar: {
    color: globalLight.white,
    backgroundColor: (0, _polished.linearGradient)({
      colorStops: [_.color.azure, _.color.purple],
      fallback: _.color.azure
    })
  },
  button: {
    backgroundColor: globalLight.primaryColor,
    color: globalLight.secondaryColor,
    ripple: (0, _polished.transparentize)(0.6, _.color.darkBlue),
    borderColor: globalLight.secondaryColor,
    borderWidth: '0'
  },
  tabs: {
    tab: {
      unselected: {
        backgroundColor: globalLight.secondaryColor,
        color: globalLight.primaryColor,
        borderColor: globalLight.primaryColor,
        borderWidth: '1px'
      },
      selected: {
        backgroundColor: globalLight.primaryColor,
        color: globalLight.secondaryColor,
        borderColor: globalLight.secondaryColor,
        borderWidth: '1px'
      }
    },
    tabPanel: {
      backgroundColor: globalLight.secondaryColor,
      color: globalLight.primaryColor
    }
  },
  accordion: {
    trigger: {
      backgroundColor: globalLight.primaryColor,
      color: globalLight.secondaryColor,
      ripple: (0, _polished.transparentize)(0.6, globalLight.secondaryColor),
      borderColor: globalLight.secondaryColor,
      borderWidth: '0'
    },
    body: {
      backgroundColor: globalLight.secondaryColor,
      color: globalLight.primaryColor
    }
  },
  modal: {
    backgroundColor: globalLight.secondaryColor,
    color: globalLight.primaryColor,
    overlayColor: (0, _polished.transparentize)(0.2, globalLight.primaryColor)
  },
  modalAssistant: {
    backgroundColor: 'linear-gradient(315deg, #7d55c7, #00b5e2 100%)',
    color: globalLight.primaryColor,
    overlayColor: (0, _polished.transparentize)(0.2, globalLight.secondaryColor),
    assistantColor: _.color.white
  },
  select: {
    placeholderColor: (0, _polished.transparentize)(0.4, globalLight.primaryColor),
    accentColor: globalLight.secondaryAccentColor,
    option: {
      unselected: {
        backgroundColor: globalLight.secondaryColor,
        color: globalLight.primaryColor
      },
      selected: {
        backgroundColor: globalLight.secondaryAccentColor,
        color: globalLight.secondaryColor
      }
    }
  },
  form: {
    errorColor: globalLight.secondaryAccentColor,
    accentColor: globalLight.secondaryAccentColor,
    placeholderColor: (0, _polished.transparentize)(0.4, globalLight.primaryColor)
  }
});

var globalDark = {
  primaryColor: _.color.darkBlue,
  secondaryColor: _.color.white,
  primaryAccentColor: _.color.azure,
  secondaryAccentColor: _.color.orange
};

var dark = _objectSpread(_objectSpread({}, globalDark), {}, {
  color: globalDark.primaryColor,
  borderColor: globalDark.primaryColor,
  backgroundColor: globalDark.secondaryColor,
  header: {
    top: {
      color: globalDark.primaryColor,
      backgroundColor: 'transparent',
      borderColor: globalDark.primaryColor,
      borderWidth: 0
    },
    scroll: {
      color: globalDark.primaryColor,
      backgroundColor: globalDark.secondaryColor,
      borderColor: globalDark.primaryColor,
      borderWidth: 0
    }
  },
  sidebar: {
    color: globalDark.primaryColor,
    backgroundColor: (0, _polished.linearGradient)({
      colorStops: [_.color.azure, _.color.purple],
      fallback: _.color.azure
    })
  },
  button: {
    backgroundColor: globalDark.primaryColor,
    color: globalDark.secondaryColor,
    ripple: (0, _polished.transparentize)(0.6, _.color.white),
    borderColor: globalDark.secondaryColor,
    borderWidth: '0'
  },
  tabs: {
    tab: {
      unselected: {
        backgroundColor: globalDark.secondaryColor,
        color: globalDark.primaryColor,
        borderColor: globalDark.primaryColor,
        borderWidth: '1px'
      },
      selected: {
        backgroundColor: globalDark.primaryColor,
        color: globalDark.secondaryColor,
        borderColor: globalDark.secondaryColor,
        borderWidth: '1px'
      }
    },
    tabPanel: {
      backgroundColor: globalDark.secondaryColor,
      color: globalDark.primaryColor
    }
  },
  accordion: {
    trigger: {
      backgroundColor: globalDark.primaryColor,
      color: globalDark.secondaryColor,
      ripple: (0, _polished.transparentize)(0.6, globalDark.secondaryColor),
      borderColor: globalDark.secondaryColor,
      borderWidth: '0'
    },
    body: {
      backgroundColor: globalDark.secondaryColor,
      color: globalDark.primaryColor
    }
  },
  modal: {
    backgroundColor: globalDark.secondaryColor,
    color: globalDark.primaryColor,
    overlayColor: (0, _polished.transparentize)(0.2, globalDark.primaryColor)
  },
  modalAssistant: {
    backgroundColor: 'linear-gradient(315deg, #7d55c7, #00b5e2 100%)',
    color: globalDark.primaryColor,
    overlayColor: (0, _polished.transparentize)(0.2, globalDark.secondaryColor),
    assistantColor: _.color.darkBlue
  },
  select: {
    placeholderColor: (0, _polished.transparentize)(0.4, globalDark.primaryColor),
    accentColor: globalDark.secondaryAccentColor,
    option: {
      unselected: {
        backgroundColor: globalDark.secondaryColor,
        color: globalDark.primaryColor
      },
      selected: {
        backgroundColor: globalDark.secondaryAccentColor,
        color: globalDark.secondaryColor
      }
    }
  },
  form: {
    errorColor: globalDark.secondaryAccentColor,
    accentColor: globalDark.secondaryAccentColor,
    placeholderColor: (0, _polished.transparentize)(0.4, globalDark.primaryColor)
  }
});

var globalAccent = {
  primaryColor: _.color.white,
  secondaryColor: _.color.darkBlue,
  primaryAccentColor: _.color.azure,
  secondaryAccentColor: _.color.orange
};

var accent = _objectSpread(_objectSpread({}, globalAccent), {}, {
  color: globalAccent.primaryColor,
  borderColor: globalAccent.primaryColor,
  backgroundColor: "linear-gradient(315deg, ".concat(_.color.purple, ", ").concat(_.color.azure, " 100%)"),
  header: {
    top: {
      color: globalAccent.primaryColor,
      backgroundColor: 'transparent',
      borderColor: globalAccent.primaryColor,
      borderWidth: 0
    },
    scroll: {
      color: globalAccent.primaryColor,
      backgroundColor: globalAccent.secondaryColor,
      borderColor: globalAccent.primaryColor,
      borderWidth: 0
    }
  },
  sidebar: {
    color: globalAccent.primaryColor,
    backgroundColor: (0, _polished.linearGradient)({
      colorStops: [_.color.azure, _.color.purple],
      fallback: _.color.azure
    })
  },
  button: {
    backgroundColor: globalAccent.primaryColor,
    color: globalAccent.secondaryColor,
    ripple: (0, _polished.transparentize)(0.6, _.color.darkBlue),
    borderColor: globalAccent.secondaryColor,
    borderWidth: '0'
  },
  tabs: {
    tab: {
      unselected: {
        backgroundColor: globalAccent.secondaryColor,
        color: globalAccent.primaryColor,
        borderColor: globalAccent.primaryColor,
        borderWidth: '1px'
      },
      selected: {
        backgroundColor: globalAccent.primaryColor,
        color: globalAccent.secondaryColor,
        borderColor: globalAccent.secondaryColor,
        borderWidth: '1px'
      }
    },
    tabPanel: {
      backgroundColor: globalAccent.secondaryColor,
      color: globalAccent.primaryColor
    }
  },
  accordion: {
    trigger: {
      backgroundColor: globalAccent.primaryColor,
      color: globalAccent.secondaryColor,
      ripple: (0, _polished.transparentize)(0.6, globalAccent.secondaryColor),
      borderColor: globalAccent.secondaryColor,
      borderWidth: '0'
    },
    body: {
      backgroundColor: globalAccent.secondaryColor,
      color: globalAccent.primaryColor
    }
  },
  modal: {
    backgroundColor: globalAccent.secondaryColor,
    color: globalAccent.primaryColor,
    overlayColor: (0, _polished.transparentize)(0.2, globalAccent.primaryColor)
  },
  modalAssistant: {
    backgroundColor: 'linear-gradient(315deg, #7d55c7, #00b5e2 100%)',
    color: globalAccent.primaryColor,
    overlayColor: (0, _polished.transparentize)(0.2, globalAccent.secondaryColor),
    assistantColor: _.color.white
  },
  select: {
    placeholderColor: (0, _polished.transparentize)(0.4, globalAccent.primaryColor),
    accentColor: globalAccent.secondaryAccentColor,
    option: {
      unselected: {
        backgroundColor: globalAccent.secondaryColor,
        color: globalAccent.primaryColor
      },
      selected: {
        backgroundColor: globalAccent.secondaryAccentColor,
        color: globalAccent.secondaryColor
      }
    }
  },
  form: {
    errorColor: globalAccent.secondaryAccentColor,
    accentColor: globalAccent.secondaryAccentColor,
    placeholderColor: (0, _polished.transparentize)(0.4, globalAccent.primaryColor)
  }
});

var baseThemeConf = {
  light: light,
  dark: dark,
  accent: accent
};
exports.baseThemeConf = baseThemeConf;

var _default = (0, _utils.composeTheme)('certilogo', {
  light: light,
  dark: dark,
  accent: accent
});

exports["default"] = _default;